// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__MJo0Z","header":"PatientBlock_header__H4Uv_","label":"PatientBlock_label__2f4N_","option":"PatientBlock_option__1e_bf"};